import styled from 'styled-components';
import { Button } from '@/components/UI/Button/Button';

export const CallButton = styled(Button)`
  height: 73px;
  padding: 10px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 54px;
    padding: 16px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
`;

export const Row = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
`;

export const PhoneNumber = styled.span`
  font-size: 18px;
  font-weight: 500;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 15px;
    font-weight: 400;
  }
`;

export const ButtonIconBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
`;

export const RevealedContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding-bottom: 10px;
`;

export const RevealedPhoneNumber = styled.a`
  font-size: 22px;
  font-weight: 700;
`;
